var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-w-full absolute pin",style:({
    transform: ("translateX(" + _vm.translateX + "px)"),
    transition: ("transform " + _vm.transitionDuration + "s"),
  })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }